import { render, staticRenderFns } from "./IntroduceCard.vue?vue&type=template&id=08c55a1a&scoped=true"
import script from "./IntroduceCard.vue?vue&type=script&lang=js"
export * from "./IntroduceCard.vue?vue&type=script&lang=js"
import style0 from "./IntroduceCard.vue?vue&type=style&index=0&id=08c55a1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c55a1a",
  null
  
)

export default component.exports